import { AbstractControl } from "@angular/forms";

export function isInErrorState(control: AbstractControl) {
    return control && !control.pristine && control.status === "INVALID";
}
